export default __webpack_public_path__ + "static/media/trikot_base_simple.ec688aa9.png";